import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
  data () {
    return {
      invoice: null,
      payout: null,
      form: {
        'to': {
          type: 'input',
          name: 'to',
          label: 'To',
          value: '',
          placeholder: 'Emails to send a latter via ;',
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        'cc': {
          type: 'input',
          name: 'cc',
          label: 'Cc',
          value: '',
          placeholder: 'Emails to send a copy via ;',
          class: 'col-12'
        },
        'subject': {
          type: 'input',
          name: 'subject',
          label: 'Subject',
          placeholder: 'Enter subject...',
          value: '',
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        'body': {
          type: 'slot',
          slotName: 'Body',
          name: 'body',
          label: 'Body',
          value: '',
          class: 'col-12'
        },
        'items': {
          type: 'slot',
          slotName: 'Items',
          name: 'items',
          label: 'Items',
          value: null,
          class: 'col-12'
        }
      },
      editorData: '',
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'strike', 'link', '|', 'NumberedList', 'BulletedList', 'blockQuote', '|', 'alignment', '|', 'undo', 'redo' ]
      },
      needSendBaseInvoice: true,
      needSendBaseWorkLogsReport: true,
      isEmailFormLoading: false,
      isSent: false,
      files: [],
      formFiles: []
    }
  },
  methods: {
    onFileUpload (files) {
      files.map((file) => {
        this.fileToBase64(file)
          .then((base64) => {
            this.files.push({
              'name': file.name,
              'type': file.type,
              'base64': base64,
              'selected': true
            })
          }).catch((err) => {
            this.$snotify.error(err, 'Error', this.$store.state.snotify)
          })
      })
    },
    submitSendEmail () {
      this.$refs.sendEmailForm.submit()
    },
    async confirmCancel (cancelCallback) {
      const confirm = await this.$root.$confirm.open(
        'Cancel sending invoice',
        'Are you sure you want to cancel sending invoice?'
      )
      if (confirm) {
        cancelCallback()
      }
    },
    async initInvoiceModalData (invoiceId) {
      this.isEmailFormLoading = true
      this.invoice = await this.$api.finances.getInvoice(invoiceId)
      this.isEmailFormLoading = false

      if (this.invoice) {
        this.isSent = this.invoice && this.invoice.email_sent_date
        if (this.invoice.client_bank_details && this.invoice.client_bank_details.client) {
          let client = this.invoice.client_bank_details.client
          this.form.to.value = client.invoice_emails && client.invoice_emails.length > 0
            ? client.invoice_emails.join(';')
            : client.email
        }
        if (this.invoice.project) {
          this.fetchBusinessDevelopers(this.invoice.project.id)
            .then(({ data }) => {
              if (data.data && data.data.email) {
                this.form.cc.value = data.data.email
              }
              this.form.cc.value += ';finances@giraffesoftware.com'
            })
        }
        this.form.subject.value = `Giraffe Software invoice ${this.invoice.invoice_number} (${this.invoice.comment})`
        this.editorData = `Hi ${this.invoice.project.name} team,<br><br>I hope you are doing well.<br><br>` +
          'You can find an invoice and time report in the attachment.<br><br>' +
          'Kind regards,<br>Giraffe Software.'
      } else {
        this.form.subject.value = 'Giraffe Software invoice %invoice_number% (%invoice_comment%)'
        this.editorData = 'Hi %project_name% team,<br><br>I hope you are doing well.<br><br>' +
          'You can find an invoice and time report in the attachment.<br><br>' +
          'Kind regards,<br>Giraffe Software.'
      }
    },
    async initPayoutModalData (payoutId) {
      this.isEmailFormLoading = true
      this.payout = await this.$api.finances.getPayout(payoutId)
      this.isEmailFormLoading = false

      if (this.payout && this.payout.contractor) {
        this.isSent = this.payout && this.payout.email_sent_date
        this.form.to.value = this.payout.contractor.email
        this.form.cc.value = 'finances@giraffesoftware.com'

        this.form.subject.value = `Giraffe Software invoice ${this.payout.payout_number} (${this.payout.comment})`
        this.editorData = `Hi ${this.payout.contractor.name},<br><br>I hope you are doing well.<br><br>` +
          'You can find an invoice and time report in the attachment.<br><br>' +
          'Kind regards,<br>Giraffe Software.'
      } else {
        this.form.subject.value = 'Giraffe Software invoice %payout_number% (%payout_comment%)'
        this.editorData = 'Hi %contractor_name%,<br><br>I hope you are doing well.<br><br>' +
          'You can find an invoice and time report in the attachment.<br><br>' +
          'Kind regards,<br>Giraffe Software.'
      }
    },
    async fetchBusinessDevelopers (projectId) {
      return this.$api.businessDevelopers.getProjectBusinessDeveloper(projectId)
    },
    sendEmail (data, emailType = 'invoice') {
      try {
        this.isEmailFormLoading = true
        let request = {
          to: data.to.value.split(';'),
          copy: data.cc.value.split(';'),
          subject: data.subject.value,
          body: this.editorData,
          sendBaseInvoice: this.needSendBaseInvoice,
          sendBaseWorkLogsReport: this.needSendBaseWorkLogsReport,
          attachments: this.files.filter((file) => {
            return file.selected
          })
        }
        const url = emailType === 'invoice'
          ? `/api/finances/invoices/${this.invoice.id}/send`
          : `/api/finances/payouts/${this.payout.id}/send`
        axios.post(url, request, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(({ data }) => {
          this.$snotify.success(
            'Invoice email successfully sent',
            'Success',
            this.$store.state.snotify
          )
          this.$emit('submit', data)
        }, error => {
          this.outputErrorNotification(error)
        }).finally(() => {
          this.isEmailFormLoading = false
        })
      } catch (error) {
        this.$snotify.error(
          error,
          'Error',
          this.$store.state.snotify
        )
      }
    },
    outputErrorNotification (error) {
      if (error.response && error.response.data) {
        let data = error.response.data
        if (data.errors) {
          const errors = Object.values(error.response.data.errors)
          for (let i = 0; i < errors.length; i++) {
            if (errors[i][0]) {
              this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
            }
          }
        } else if (data.message) {
          this.$snotify.error(data.message, 'Error', this.$store.state.snotify)
        }
      }
    }
  }
}
